/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCompany } from "../../reducers/companySlice";
import styles from "./suspendedAccountModal.module.css";

const SuspendedModal = () => {
    const company = useSelector(selectCompany);

    // Bloqueamos si el balance es -5 o menor (ej: -6, -10...)
    const isSuspended = useMemo(() => {
        return company &&
            typeof company.BalanceDays === 'number' &&
            company.BalanceDays <= -5;
    }, [company]);

    if (!isSuspended) return null;

    return (
        <div className={styles.fullPageOverlay}>
            <div className={styles.glassCard}>
                <div className={styles.header}>
                    <div className={styles.warningIcon}>!</div>
                    <h1 className={styles.title}>Servicio Suspendido</h1>
                </div>

                <div className={styles.content}>
                    <p className={styles.mainText}>
                        Tu cuenta presenta un retraso de <strong>{Math.abs(company.BalanceDays)} días</strong> en el pago de la suscripción.
                    </p>

                    <div className={styles.alertBox}>
                        El acceso a la plataforma ha sido restringido temporalmente hasta que se regularice la situación.
                    </div>

                    {/* <a
                        href={routes.COMPANY_PAYMENTS_SETTINGS.path}
                        className={styles.actionButton}
                    >
                        Pagar Suscripción
                    </a> */}

                    <p className={styles.supportText}>
                        ¿Tienes dudas? Contacta a soporte técnico.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SuspendedModal;